module.exports = __webpack_public_path__ + "static/Q1_2023_Investor_Presentation-fc62bb2ab45c66ac1c787c7c5d2a68b2.pdf";